<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.6 14.7998H21.2H32.4C33.3 14.7998 34 15.4998 34 16.3998V19.5998C34 20.4998 33.3 21.1998 32.4 21.1998H21.2H3.6C2.7 21.1998 2 20.4998 2 19.5998V16.3998C2 15.4998 2.7 14.7998 3.6 14.7998Z"
      fill="#212121"
    />
  </svg>
</template>
